import React, { Suspense, lazy, useEffect, useState } from 'react';
import { Route } from 'react-router-dom';
import { BrowserRouter } from 'react-router-dom';
import { Switch } from 'react-router';
import { connect } from 'react-redux';
import { useIdleTimer } from 'react-idle-timer';
import { ToastContainer } from 'react-toastify';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import { Button } from '@material-ui/core';
/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

/* Theme variables */
import './theme/variables.css';
import './App.scss';
import { RootState } from './models/RootState';
import NotificationPage from './components/NotificationPage/NotificationPage';
import Login from './pages/LoginPage/LoginPage';
import AcceptTerms from './pages/AcceptTerms/AcceptTerms';
import { logout } from './store';
import ResetPassword from './pages/ResetPasswordPage/ResetPasswordPage';
import AccessRedirect from './pages/AccessRedirect/Accessredirect';
import { setTimeout } from 'timers';
import LoadingPage from './pages/LoadingPage/LoadingPage';
const MainPage = lazy(() => import('./router/UserRouter'));

type StateProps = {
  logout: () => void;
  prefersDark: string;
  loggedIn: boolean;
};

const App: React.FC<StateProps> = (props) => {
  const consoleOpen = useConsoleOpen();
  // const consoleOpen = false;

  const { logout, prefersDark, loggedIn } = props;
  const [idleModal, setIdleModal] = useState<boolean>(false);
  const timeout = 1000 * 60 * 45;
  const [isIdle, setIsIdle] = useState(false);

  useEffect(() => {
    const toggleTheme = (theme) => {
      if (theme === 'dark') {
        document.body.setAttribute('data-theme', 'dark');
      } else if (theme === 'light') {
        document.body.setAttribute('data-theme', 'light');
      } else if (theme === 'green') {
        document.body.setAttribute('data-theme', 'green');
      } else if (theme === 'purple') {
        document.body.setAttribute('data-theme', 'purple');
      } else if (theme === 'blue') {
        document.body.setAttribute('data-theme', 'blue');
      } else if (theme === 'orange') {
        document.body.setAttribute('data-theme', 'orange');
      } else if (theme === 'pink') {
        document.body.setAttribute('data-theme', 'pink');
      } else if (theme === 'pink1') {
        document.body.setAttribute('data-theme', 'pink1');
      } else if (theme === 'green1') {
        document.body.setAttribute('data-theme', 'green1');
      } else if (theme === 'brown') {
        document.body.setAttribute('data-theme', 'brown');
      }
    };

    let systemDark = window.matchMedia(
      `(prefers-color-scheme: ${prefersDark})`
    );
    systemDark.addListener((e) => toggleTheme(prefersDark));
    let a = [
      'dark',
      'light',
      'green',
      'purple',
      'blue',
      'orange',
      'pink',
      'pink1',
      'green1',
      'brown',
    ];
    a.splice(a.indexOf(prefersDark), 1);
    document.body.classList.remove(...a);
    document.body.classList.toggle(prefersDark, true);
  }, [prefersDark]);

  const handleClose = () => {
    console.log('user open dev tools');
  };

  const handleOnActive = () => setIsIdle(false);
  const handleOnIdle = () => {
    if (loggedIn) {
      setIsIdle(true);
      setIdleModal(true);
    } else handleReset();
  };

  const closeIdleModal = () => {
    if (loggedIn) {
      setIsIdle(false);
      logout();
    }
  };
  const ContinueActive = () => {
    if (loggedIn) {
      setIdleModal(false);
      setIsIdle(false);
    }
  };
  const {
    reset,
    // pause,
    // resume,
  } = useIdleTimer({
    timeout,
    onActive: handleOnActive,
    onIdle: handleOnIdle,
  });

  const handleReset = () => reset();
  return (
    <>
      {!consoleOpen ? (
        <Suspense fallback={<LoadingPage />}>
          <BrowserRouter>
            <Switch>
              <Route path="/access-redirect" component={AccessRedirect} />
              <Route path="/terms-and-conditions" component={AcceptTerms} />
              <Route path="/reset-password" component={ResetPassword} />
              <Route path="/allAnnouncement" component={NotificationPage} />
              <Route path="/login" component={Login} />
              <Route path="/" component={MainPage} />
            </Switch>
          </BrowserRouter>
        </Suspense>
      ) : null}

      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

      <Dialog
        open={consoleOpen}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
        fullWidth={true}
        className="dev-tools-msg-modal"
      >
        <DialogContent className="modal-content-ctn">
          <div className="dev-tools-warning-msg">
            {' '}
            Due to some inactivity or security reasons stop your website, please
            close the developer tool. Thank you for your support
          </div>
        </DialogContent>
      </Dialog>

      <Dialog
        open={idleModal}
        onClose={() => closeIdleModal()}
        aria-labelledby="responsive-dialog-title"
        fullWidth={true}
        className="dev-tools-msg-modal"
      >
        <div className="modal-content-ctn">
          <div className="carw">
            <div className="arrow arrow-right">Page Expired</div>
          </div>
          <div className="dev-tools-warning-msg">
            <div className="msg">
              <div className="alert">Time-Out Alert</div>{' '}
              <p className="dsc">
                {' '}
                You have been inactive for a long time your session is expired.
                Confirm to renew session.
              </p>
              <div className="dsc-btn">
                <Button onClick={() => ContinueActive()} className="btn">
                  Continue
                </Button>
                <Button onClick={() => closeIdleModal()} className="btn1">
                  Logout
                </Button>
              </div>
            </div>
          </div>
        </div>
      </Dialog>
    </>
  );
};

export const useConsoleOpen = () => {
  const [consoleOpen, setConsoleOpen] = useState(false);

  useEffect(() => {
    let checkStatus;

    var element = new Image();
    Object.defineProperty(element, 'id', {
      get: function () {
        checkStatus = true;
        throw new Error('Dev tools checker');
      },
    });
    requestAnimationFrame(function check() {
      setTimeout(() => {
        checkStatus = false;
        // Don't delete this console statements
        if (process.env.REACT_APP_NODE_ENV !== 'development') {
          // console.dir(element);
          // console.clear();
        }
        setConsoleOpen(checkStatus);
        requestAnimationFrame(check);
      }, 1000);
    });
  });

  return false;
};

const mapStateToProps = (state: RootState) => {
  return {
    prefersDark: state.common.prefersDark,
    loggedIn: state.auth.loggedIn,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    logout: () => dispatch(logout()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
